// extracted by mini-css-extract-plugin
export default {"table":"Doc_table__IfUSQ","form_control_label":"Doc_form_control_label__u4QWB"};